export default __webpack_public_path__ + "static/media/hhh.7dd12f07.gif";